import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/SimSummaryTable.css';

function SimHistory() {  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState([]);

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const [selectedDate, setSelectedDate] = useState(getTodayDate());

  const handleSearch = (dateValue) => {
    setError(null);
    setLoading(true);

    const schema = {
      createdat: dateValue,
    };
    
    axios
      .post(process.env.REACT_APP_BACKEND_ADDRESS + '/rpt/getsimhistory', schema)
      .then((response) => {
        setLoading(false);

        if (response.data.description === 'ok') {
          setResult(response.data.data || []);
        } else {
          setResult([]);
          setError(response.data.description || 'Failed to fetch data');
        }
      })
      .catch((requestError) => {
        setLoading(false);
        setResult([]);
        setError(requestError?.response?.data?.description || requestError.message || 'Failed to fetch data');
      });
  };

  useEffect(() => {
    handleSearch(getTodayDate());
  }, []);

  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
        <input
          type="button"
          id="btnSearch"
          value={loading ? 'Loading...' : 'Search'}
          onClick={() => handleSearch(selectedDate)}
          disabled={loading}
          style={{ marginLeft: '8px' }}
        />
      </div>

      <div className="table-wrap">
        <table className="sim-table sim-history-table">
          <thead>
            <tr>
              <th className="game-head">No</th>
              <th className="game-head">User ID</th>
              <th className="game-head">Game Name</th>
              <th className="game-head">Game Mode</th>
              <th className="game-head">Sim Count</th>
              <th className="game-head">Status</th>
              <th className="game-head">Error</th>
              <th className="game-head">Created At</th>
              <th className="game-head">Completed At</th>
            </tr>
          </thead>
          <tbody>
            {result.map((row, index) => (
              <tr key={`${row.playerid || 'player'}-${row.token || 'token'}-${index}`}>
                <td>{index + 1}</td>               
                <td>{row.playername} / {row.playerid}</td>                
                <td className="userid">{row.gamename}</td>
                <td>{row.gameMode}</td>
                <td>{row.simcount} / {row.totalsim}</td>                
                <td className={row.status === 'completed' ? 'pos' : 'neg'}>{row.status}</td>
                <td>{row.errmsg}</td>
                <td>{row.createdat ? new Date(row.createdat).toLocaleString() : ''}</td>
                <td>{row.completedat ? new Date(row.completedat).toLocaleString() : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {error && <><small style={{ color: 'red' }}>{error}</small><br /></>}<br />

    </div>
  );
}

export default SimHistory;